// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateLaborAdditiveSummaryModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/labor-additive-summary-modal-visibility.js